export default __webpack_public_path__ + "static/media/src_jquery_desktop_2.d33965c2.jpg";